<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        class="popup-mark-phone-call-done"
        :title="$t.__('activities.popupMarkPoneCallDone.title')"
        @closed="$emit('close')"
    >
        <compassLoader v-if="isLoading" class="phonecall-mark-done--loading" size="large" />

        <div v-else class="phonecall-mark-done__content">
            <RichText
                v-model="tempDescription"
                class="description-input-max-height"
                :formitem="{
                    label: $t.__('common.labels.note'),
                }"
            />
            <div class="container-result-duration">
                <CompassFormItem
                    class="result"
                    :label="$t.__(`activities.popupMarkPoneCallDone.result`)"
                >
                    <CompassSelect v-model="resultPhoneCall" menuClass="select-result-phonecall">
                        <CompassDropdownOption
                            v-for="result in resultOptions"
                            :key="result.id"
                            :label="result.label"
                            :value="result.id"
                        />
                    </CompassSelect>
                </CompassFormItem>
                <CompassFormItem :label="$t.__(`activities.popupMarkPoneCallDone.duration`)">
                    <DurationInput v-model="durationInput" placeholder="00:00:00" />
                </CompassFormItem>
            </div>
        </div>
        <template #footer>
            <div v-if="!isLoading" class="phonecall-mark-done__footer">
                <CompassButton
                    type="secondary"
                    :label="$t.__('common.actions.cancel')"
                    :disabled="isSubmitting"
                    @click="$emit('close')"
                />
                <CompassButton
                    :loading="isSubmitting"
                    :label="$t.__('common.actions.save')"
                    @click="handleConfirm"
                />
            </div>
        </template>
    </CompassModal>
</template>
<script>
import RichText from 'vcomponents/richtext/RichText.vue';
import { fetchActivitiesCrmMetas } from 'api/activities/activitiesService.js';
import ActivityFormService from 'api/activities/activityFormService.js';
import DurationInput from 'vcomponents/inputs/DurationInput.vue';

export default {
    components: {
        RichText,
        DurationInput,
    },
    props: {
        idPhoneCall: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            default: () => {},
        },
        date: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showModal: true,
            isLoading: true,
            tempDescription: '',
            durationInput: '',
            resultOptions: [],
            resultPhoneCall: 'connected',
            isSubmitting: false,
            activityFormService: new ActivityFormService('phonecall'),
        };
    },
    computed: {
        duration() {
            if (!this.durationInput) {
                return 0;
            }

            const durationSplit = this.durationInput.split(':');

            const hours = +durationSplit[0] ?? 0;
            const minutes = +durationSplit[1] ?? 0;
            const seconds = +durationSplit[2] ?? 0;
            return hours * 3600 + minutes * 60 + seconds;
        },
    },
    async created() {
        try {
            this.tempDescription = this.description;
            let metas = this.$store.getters['activitiesStores/getMetas'];

            if (!metas) {
                const { data } = await fetchActivitiesCrmMetas();
                metas = data;
            }
            this.resultOptions = metas.phonecall.statuses.filter(
                (status) => status.id !== 'scheduled',
            );
        } catch (error) {
            console.error(error);
            this.$emit('close');
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        async handleConfirm() {
            try {
                this.isSubmitting = true;

                let description = this.tempDescription || '';
                description = description.replaceAll('<p></p>', '<br />');
                description = description.replace(RegExp('<\/?p>', 'g'), '');

                let payload = {
                    id: this.idPhoneCall,
                    description,
                    result: this.resultPhoneCall,
                    duration: this.duration,
                };
                if (moment().isBefore(this.date)) {
                    payload = {
                        ...payload,
                        date: moment().toISOString(),
                    };
                }
                await this.activityFormService.updateActivity(payload);

                this.$pushToast({
                    type: 'success',
                    close: true,
                    text: this.$t.__('activities.markAsDone.success'),
                });
                this.callback();
                if (this.$store.state.popupPanel?.activityDetailPanel?.display) {
                    this.$store.dispatch('popupPanel/close', { key: 'activityDetailPanel' });
                }
            } catch (error) {
                console.error(error);
                this.$pushToast({
                    type: 'error',
                    close: true,
                    text: this.$t.__(
                        'activities.detailPanel.ActivityDetailPanel.errorUpdateStatus',
                    ),
                });
            } finally {
                this.isSubmitting = false;
                this.$emit('close');
            }
        },
    },
};
</script>

<style lang="scss">
.popup-mark-phone-call-done {
    .compass-modal__modal__content:has(.phonecall-mark-done--loading) {
        padding: var(--spacing-7) 0 88px;
        margin: auto auto var(--spacing-5);
    }
    .phonecall-mark-done--loading {
        height: var(--spacing-7);
        width: var(--spacing-7);

        .compass-loader__circle,
        .compass-loader__circle > svg {
            width: var(--spacing-7);
            height: var(--spacing-7);
        }
    }
    .phonecall-mark-done {
        &__content {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-4);

            .compass-form-item {
                flex: 1 1 50%;
            }

            .container-result-duration {
                display: flex;
                gap: var(--spacing-3);
            }

            .description-input-max-height {
                .ProseMirror {
                    height: 110px;
                    max-height: 110px;
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            gap: var(--spacing-3);
            padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
        }
    }
}
#compass-dropdown-container {
    .select-result-phonecall {
        z-index: 1001;
    }
}
</style>
